// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1Acp2","header":"PatientQuestionnaire_header__2VW0S","info":"PatientQuestionnaire_info__1di7e"};